module.exports = __webpack_public_path__ + "img/female-bg-white.a8a05e54.svg";